import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-md-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "activityAdditionalInfo" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = {
  key: 0,
  class: "list-unstyled"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 1,
  class: "list-unstyled"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "All Day", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "list-unstyled"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", null, "TBD", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-md-1 text-right pr-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "btn desktop-only" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" })
], -1)
const _hoisted_17 = { class: "btn mobile-only w-100 text-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "row activity activity-featured",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitSelectedActivity()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.calendarContent.displayName), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.calendarContent.locationName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.activityDaySchedule.isAllDayEvent && !_ctx.activityDaySchedule.toBeDetermined)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityDaySchedule.schedules, (schedule) => {
              return (_openBlock(), _createElementBlock("li", {
                key: schedule.sortKey
              }, [
                (schedule.prependText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(schedule.prependText), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(schedule.displayStart) + " ", 1),
                (schedule.displayEnd)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "— " + _toDisplayString(schedule.displayEnd), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (schedule.appendText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(schedule.appendText), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.activityDaySchedule.isAllDayEvent)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_9, _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.activityDaySchedule.toBeDetermined)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("button", _hoisted_17, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSelectedActivity()))
        }, _hoisted_19)
      ])
    ])
  ]))
}